'use strict';

exports.__esModule = true;
exports.default = {
  SMALL: 'small',
  LARGE: 'large'
};
//# sourceMappingURL=LikeSize.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-facebook/lib/constants/LikeSize.js
// module id = 386
// module chunks = 0